export const GETME: string = "ART_GET_ME"; // user info
export const AVATAR: string = "AVATAR";
export const TOKEN: string = "TOKEN";
export const LANG: string = "LANG";
